/**
 * The words for profile strength — read through the typed key maps beside
 * this file, for the web portal and the phone alike, so the key-usage gate
 * checks every one against en.json and both apps name an item the same way. Which item matters for what is decided by the
 * server (`tags`); this only names it.
 */
import {
  PROFILE_STRENGTH_ITEM_KEY,
  PROFILE_STRENGTH_LEVEL_KEY,
  PROFILE_STRENGTH_TAG_KEY,
  PROFILE_STRENGTH_WHY_KEY,
} from './profile-strength-keys';
import type {
  ProfileStrengthItemKey,
  ProfileStrengthLevel,
  ProfileStrengthTag,
} from '@tonnie/types';
import type { TFunction } from 'i18next';

export const strengthItemLabel = (t: TFunction, key: ProfileStrengthItemKey): string =>
  t(PROFILE_STRENGTH_ITEM_KEY[key]);

/** Why an item matters — the pillar it feeds, or the gate it opens. */
export const strengthItemWhy = (t: TFunction, key: ProfileStrengthItemKey): string =>
  t(PROFILE_STRENGTH_WHY_KEY[key]);

export const strengthTagLabel = (t: TFunction, tag: ProfileStrengthTag): string =>
  t(PROFILE_STRENGTH_TAG_KEY[tag]);

export const strengthLevelLabel = (t: TFunction, level: ProfileStrengthLevel): string =>
  t(PROFILE_STRENGTH_LEVEL_KEY[level]);
